import DataCacheService from '@/shared/services/DataCacheService';
import CurrencySymbols from '@/shared/currencySymbols';

const getCurrencySymbol = () => {
  let currencyCode = 'EUR';

  const cache = DataCacheService.getDataCache();
  if (cache) {
    ({ currencyCode } = cache.defaultcompany);
  }
  return CurrencySymbols.getByCurrencyCode(currencyCode);
};

export const numberTooltipLabel = context => {
  let label = context.dataset.label || '';
  if (label) label += ': ';
  if (context.parsed.y !== null) {
    label += context.parsed.y.toFixed(2);
  }
  return label;
};

export const currencyTooltipLabel = context => {
  let label = context.dataset.label || '';
  if (label) label += ': ';
  if (context.parsed.y !== null) {
    label += context.parsed.y.toFixed(2) + getCurrencySymbol();
  }
  return label;
};

export const NoDecimalsTooltipLabel = (context, afterLabel) => {
  let label = context.dataset.label || '';
  if (label) label += ': ';
  if (context.parsed !== null) {
    if (context.parsed.y || context.parsed.y === 0) {
      label += context.parsed.y;
    } else {
      label += context.parsed;
    }
  }
  if (afterLabel) label += ` ${afterLabel}`;
  return label;
};

export const currencyTooltipLabelWithInlt = (context, intl) => {
  let label = context.dataset.label || '';
  if (label) label += ': ';
  const value = intl.formatNumber(context.parsed.y || 0, {
    format: 'currency',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${label}${value}`;
};
export const percentageTooltipLabel = context => {
  let label = context.dataset.label || '';
  if (label) label += ': ';
  if (context.formattedValue !== null) {
    label += `${context.formattedValue}%`;
  }
  return label;
};
